var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"phone"},[_c('video',{attrs:{"src":require("../assets/video/iphone.mp4"),"autoplay":"","loop":"","muted":"","width":"280"},domProps:{"muted":true}}),_c('img',{attrs:{"src":require("../assets/img/iphone.png"),"alt":"iPhone"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }